import * as Language from '../../tools/constants/language';
import { ATTR_DISABLED } from "../../tools/constants/attributes";
import { CLASS_DISABLED, CLASS_SUCCESS } from '../../tools/constants/classes';
import { printMoney, t } from '@process-creative/slate-theme-tools';
import { generateLoader } from "../../objects/loader";
const SELECTOR_BTN_ADD = '[data-add-to-cart-button]';
const SELECTOR_BTN_INNER = '[data-add-to-cart-button-inner]';
const ATTR_NOTIFY_BTN = 'data-notify-btn';

export const formatMoneyCurrency: (price: number, position?: 'first' | 'last') => string = (price, position = 'first') => {
  const money = String(printMoney(price, 'money_format_with_currency').replace('.00',''));
  if (position === 'first') {
    const parts = money.split(' ');
    return `${parts[1]} ${parts[0]}`;
  } else {
    return money;
  }
}

export class ButtonAddToCart {
  buttonAdd: HTMLElement | null;
  buttonInner: HTMLElement | null;

  constructor(container?: HTMLElement | null) {
    if (!container) {
      container = document.querySelector('body');
    }
    this.buttonAdd = container?.querySelector<HTMLButtonElement>(SELECTOR_BTN_ADD) || null;
    this.buttonInner = this.buttonAdd?.querySelector<HTMLElement>(SELECTOR_BTN_INNER) || null;  
  }

  btnDisable() {
    if(!this.buttonAdd || !this.buttonInner) return;
    this.buttonAdd.classList.add(CLASS_DISABLED);
    this.buttonAdd.setAttribute(ATTR_DISABLED, ATTR_DISABLED);
    this.buttonInner.innerHTML = t(Language.PRODUCT_SOLD_OUT);
  }
  
  btnNotSelected() {
    if(!this.buttonAdd || !this.buttonInner) return;
    this.buttonAdd.classList.add(CLASS_DISABLED);
    this.buttonAdd.setAttribute(ATTR_DISABLED, ATTR_DISABLED);
  }
  
  btnNotify() {
    if(!this.buttonAdd || !this.buttonInner) return;
    this.buttonAdd.removeAttribute(ATTR_DISABLED);
    this.buttonAdd.setAttribute(ATTR_NOTIFY_BTN, ATTR_NOTIFY_BTN);
    this.buttonInner.innerHTML = t(Language.PRODUCT_NOTIFY_ME);
  }
  
  btnEnable() {
    if(!this.buttonAdd || !this.buttonInner) return;
    this.buttonAdd.classList.remove(CLASS_DISABLED);
    this.buttonAdd.removeAttribute(ATTR_DISABLED);
    this.buttonAdd.removeAttribute(ATTR_NOTIFY_BTN);
    this.buttonInner.innerHTML = t(Language.PRODUCT_ADD_TO_CART);
  }
  
  btnAllInCart() {
    if(!this.buttonAdd || !this.buttonInner) return;
    this.buttonAdd.classList.add(CLASS_DISABLED);
    this.buttonAdd.setAttribute(ATTR_DISABLED, ATTR_DISABLED);
    this.buttonInner.innerHTML = t(Language.PRODUCT_ALL_IN_CART);
  }

  get() {
    return this.buttonAdd
  }

  exists() {
    if (!this.buttonAdd) {
      return false;
    }
    return true;
  }

  loading() {
    if(this.buttonInner) this.buttonInner.innerHTML = generateLoader({size:26});
  }

  added() {
    if(this.buttonInner) {
      const buttonInner = this.buttonInner;
      this.buttonInner.innerHTML = `<svg class="o-icon c-product-details__add-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37" xml:space="preserve"><path class="o-icon__path" fill="none" stroke="#fff" stroke-width="3" stroke-linejoin="round" stroke-miterlimit="10" d="m11.6 20 4.3 4.2 10.5-10.4"/></svg>`;
      setTimeout(() => buttonInner.classList.add(CLASS_SUCCESS), 50);
    }
  }

  error() {
    if(this.buttonInner) this.buttonInner.innerHTML = t(Language.PRODUCT_ERROR);
  }

  reset() {
    if(this.buttonInner) this.buttonInner.classList.remove(CLASS_SUCCESS);
  }
}

export const handleize = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '')
}